<lib-print-agent-guide />

@let prompt = flow.prompt();
<p-dialog
  [visible]="!!prompt"
  (visibleChange)="!$event && flow.answerPrompt(null)"
  [modal]="true"
  [draggable]="false"
  [closable]="true"
  appendTo="body"
  [style]="{ width: 'min(92vw, 480px)' }"
  [header]="prompt?.title ?? ''"
>
  @if (prompt) {
    <div class="pc-prompt">
      <p>{{ prompt.message }}</p>
      @if (prompt.hint) {
        <p class="pc-prompt__hint"><i class="pi pi-lightbulb"></i>{{ prompt.hint }}</p>
      }
    </div>
  }
  <ng-template pTemplate="footer">
    @for (btn of prompt?.buttons ?? []; track btn.value) {
      <p-button
        [label]="btn.label"
        [severity]="btn.severity ?? 'primary'"
        [outlined]="!!btn.outlined"
        (click)="flow.answerPrompt(btn.value)"
      />
    }
  </ng-template>
</p-dialog>

@if (flow.widgetVisible() && flow.jobs().length) {
  <section class="pc-widget" aria-live="polite">
    <header class="pc-widget__head">
      <i class="pi pi-print"></i>
      <span class="pc-widget__title">{{ flow.t('print_queue_title', 'Chop etish navbati') }}</span>
      @if (flow.activeCount()) {
        <span class="pc-widget__count">{{ flow.activeCount() }}</span>
      }
      <button
        type="button"
        class="pc-icon-btn"
        [attr.aria-label]="flow.t('close', 'Yopish')"
        (click)="flow.closeWidget()"
      >
        <i class="pi pi-times"></i>
      </button>
    </header>

    <ul class="pc-widget__list">
      @for (job of flow.jobs(); track job.localId) {
        @let view = jobView(job);
        <li class="pc-job">
          <i [class]="view.icon + ' pc-job__icon'" [attr.data-tone]="view.tone"></i>
          <div class="pc-job__body">
            <span class="pc-job__file" [title]="job.fileName">{{ job.fileName }}</span>
            <span class="pc-job__meta">{{ job.printer }}</span>
            <span class="pc-job__status" [attr.data-tone]="view.tone">{{ view.label }}</span>
          </div>
          @if (isActive(job)) {
            <button
              type="button"
              class="pc-icon-btn"
              [pTooltip]="flow.t('print_cancel', 'Bekor qilish')"
              tooltipPosition="left"
              (click)="flow.cancel(job)"
            >
              <i class="pi pi-times-circle"></i>
            </button>
          } @else if (canRetry(job)) {
            <button
              type="button"
              class="pc-icon-btn"
              [pTooltip]="flow.t('print_retry', 'Qayta urinish')"
              tooltipPosition="left"
              (click)="flow.retry(job)"
            >
              <i class="pi pi-refresh"></i>
            </button>
          } @else {
            <button
              type="button"
              class="pc-icon-btn"
              [pTooltip]="flow.t('remove', 'Olib tashlash')"
              tooltipPosition="left"
              (click)="flow.removeJob(job.localId)"
            >
              <i class="pi pi-times"></i>
            </button>
          }
        </li>
      }
    </ul>

    @if (finishedCount() && !flow.activeCount()) {
      <footer class="pc-widget__foot">
        {{ flow.t('print_queue_all_done', 'Barcha hujjatlar printerga yuborildi') }}
      </footer>
    }
  </section>
}
